import { render } from "./VerifyEmailSuccess.vue?vue&type=template&id=5c868ba3&scoped=true"
import script from "./VerifyEmailSuccess.vue?vue&type=script&lang=js"
export * from "./VerifyEmailSuccess.vue?vue&type=script&lang=js"

import "./VerifyEmailSuccess.vue?vue&type=style&index=0&id=5c868ba3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c868ba3"]])

export default __exports__